<template>
  <div class="pd-t10 company-dynamic-details">
  
    <div class="block-center w1200">
      <div class="clear">
        <div class="fr company-dynamic-crumb-list">
          <div class="fl">您所在位置：</div>
          <div class="fl company-dynamic-crumb-list-item">公司动态</div>
          <div class="fl company-dynamic-crumb-list-item">公司要闻</div>
        </div>
      </div>
    </div>
    
    <div class="block-center w1200">
      
      <div :title="title" style="padding:24px 0" class="f36  company-dynamic-title">
        {{ title }}
      </div>
      
      <div class="mg-b40 details-box">
        <div v-html="content"></div>
  
        <!-- <p>债务咨询是指债务市场中的咨询和中介活动。除了简单的经纪活动之外，还包括构建咨询服务，实施竞争性招标类流程和协助融资文件谈判，无论是融资业务。收购，再融资或债务重组。债务顾问在金融交易中扮演银行家的角色，在某些情况下可能需要完全支持融资职能，才能让投资者获得其团队。</p>
        <p>在法国，债务咨询是由银行业务和支付服务中的经纪人许可（COBSP）批准的受ACPR控制的受监管活动。虽然这项活动在盎格鲁撒克逊人和主要北美洲的世界已经存在了很多年，但它最近在欧洲大陆已经结构化，特别是在2008年危机和随后出现的信贷危机之后。随着银行业监管的加强和银行业务流程的加重，结构的复杂性以及运营商数量的增加，有必要创建平台来简化投资者的工作并优化在日益复杂的世界中融资的条件。</p>
        <p>债务咨询是指债务市场中的咨询和中介活动。除了简单的经纪活动之外，还包括构建咨询服务，实施竞争性招标类流程和协</p>

        <div class="mg-tb10 text-center pic">
          <img :src="publicPath + 'static/images/dynamic/dynamic_details_01.jpg'" alt="">
        </div>
  
        <p>债务咨询是指债务市场中的咨询和中介活动。除了简单的经纪活动之外，还包括构建咨询服务，实施竞争性招标类流程和协助融资文件谈判，无论是融资业务。收购，再融资或债务重组。债务顾问在金融交易中扮演银行家的角色，在某些情况下可能需要完全支持融资职能，才能让投资者获得其团队。</p>
        <p>在法国，债务咨询是由银行业务和支付服务中的经纪人许可（COBSP）批准的受ACPR控制的受监管活动。虽然这项活动在盎格鲁撒克逊人和主要北美洲的世界已经存在了很多年，但它最近在欧洲大陆已经结构化，特别是在2008年危机和随后出现的信贷危机之后。</p>
         -->
      </div>
      
      <!-- <div class="clear mg-b30 prev-next">
        <div class="fl">
          <span>←上一篇：38女神节-“种植小鲜肉、共庆女神节”DI...</span>
        </div>
        
        <div class="fr">
          <span>→下一篇：传统与现代碰撞，打造中国式高品质生活...</span>
        </div>
      </div>
       -->
    </div>
  
  </div>
</template>

<script>
export default {
  name: "company-dynamic",

  data() {
    return {
      id: '',
      title: '',
      content:''
    }
  },
  created(){
    this.id = this.$route.query.id 
    this.getDetails()
  },
  methods: {
    getDetails(){
      let url = 'https://homeserver.test.hedejj.com/article/api/getById/' + this.id
      this.post(url,null).then(res=>{
        this.title = res.data.title
        this.content = res.data.content
        window.scrollTo(0,0);
      })
    },
    handleCurrentChange(val) {
      console.log(`当前是第${val}页`);
    }
  },

  mounted() {
  
  }
}
</script>